<template>
    <div class="page">
        <div class="title"> 
            <div class="top">
                <div class="top-item">预充值卡</div>
                <div class="top-items">{{recordLoginText}}</div>
            </div>
            <div class="yuer">  ￥{{ money_format(userAccount.amount / 100, 2, ".", ",") * 1 }}</div>
            <div class="smallyue">卡内余额(元)</div>
            <div class="cz" @click="toRecharge">充值本卡</div>
            <div class="bot">
                <div class="bot-left">我的活动余额：￥{{ simInfo.tuiPrice }}</div>
                <div class="bot-right" @click="detailsTo">详情</div>
            </div>
        </div>
        <img src="@/assets/new/newCopy/icon11.png" alt="" class="img">
    </div>
</template>
<script>
import { Toast,Dialog } from 'vant';
import { wxRequest } from "@/api/user.js";
export default{
    data(){
        return{
           userAccount: {},
           simInfo: {},
           recordLoginText: localStorage.getItem('recordLoginText'),
           iccid: localStorage.getItem('iccid'),
        }
    },
    created(){
       this.getAccount();
       this.getInfo();
    },
    methods:{
         toRecharge() {
      this.$router.replace('/newUser/recharge')
    },
    detailsTo() {
      this.$router.push({
        path: '/newUser/coupon',
        query: {
          iccid: this.iccid
        }
      })
    },
     getAccount() {
      const param = {
        iccid: this.iccid,
        mobile: localStorage.getItem('mobile')
      }
      // 若为总部微信公众号
      if (localStorage.getItem('isHeadquarterAppid')) {
        wxRequest('/sysUser/account/querySysUserAccount', param, 'post').then(
          (res) => {
            if (res.data.code === '200') {
              this.userAccount = res.data.data
              this.alreadyHasAccount = true
            } else if (res.data.code === '400') {
              const self = this
              if (self.$store.state.supplierCode === '1197749413972275200') {
                Dialog.confirm({
                  title: '提示',
                  message: '首次使用需进行充值，请点击【确认】前往充值'
                })
                  .then(() => {
                    self.$router.replace('/newUser/recharge')
                  })
                  .catch(() => {})
              }
            }
          }
        )
      } else {
        // 若为代理商公众号
        wxRequest('/sysUser/account/querySysUserAccount', param, 'post').then(
          (res) => {
            if (res.data.code === '200') {
              this.userAccount = res.data.data
              this.alreadyHasAccount = true
            }
          }
        )
      }
    },
    getInfo() {
      wxRequest('sim/detail', { iccid: this.iccid }, 'post').then((res) => {
        if (res.data.code === '200') {
          this.simInfo = res.data.data
        } else {
          Toast.fail(res.data.message)
        }
      })
    },


    }
}
</script>

<style lang="less" scoped>
.page{
    padding:0 13px;
    background: linear-gradient(180deg, #3980F9 0%, rgba(244, 246, 250, 1) 240px);
    height:calc(100% - 21px);
    padding-top:21px;
    position: relative;
    .title{
        width: 350px;
        height: 238px;
        background: #FFFFFF;
        border-radius: 10px;
        margin: 0 auto;
        position: relative;
        .top{
            display: flex;
            height: 57px;
            padding-left:11px;
            align-items: center;
            background: linear-gradient(180deg, #B1CEFF 0%, #FFFFFF 100%);
            border-radius: 10px 10px 0px 0px;
            .top-item{
                font-size: 12px;
                font-family: HarmonyOS_Sans_SC;
                color: #FFFFFF;
                text-align: center;
                line-height: 17px;
                width:62px;
                background: url('./../../assets/new/newCopy/icon12.png') no-repeat center;
                background-size:100% 100%;
            }
            .top-items{
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #28292D;
                line-height: 22px;
                padding-left:10px;
            }
        }
        .yuer{
            height: 50px;
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #28292D;
            text-align: center;
            line-height: 50px; 
            margin-top:36px;
        }
        .smallyue{
            text-align: center; 
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
        }
        .cz{
            width:88px;
            height: 31px;
            background: url('../../assets/new/newCopy/icon13.png') no-repeat center;
            background-size:100% 100%;
            position: absolute;
            right: 0;
            top: 40%;
            text-align: center;
            line-height:30px;
            color: #fff;
        }
        .bot{
            width:88%;
            margin:27px auto 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top:1px solid #F3F3F3;
            padding-top:14px;
            .bot-right{
               color:#397FF9;
            }
        }
    }
    .img{
        width:96%;
        height: 90px;
        margin: 20px auto;
        display: block;
    }
}
</style>